<template>
  <v-tooltip top>
    <v-btn
      slot="activator"
      flat
      small
      icon
      class="my-0"
      @click="downloadOutputForm()"
    >
      <v-icon>grid_on</v-icon>
    </v-btn>
    <span>Экспорт в Excel</span>
  </v-tooltip>
</template>

<script>
import { getShippingOutputForm } from "../../../../backend/shippingsApi.js";

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    number: {
      type: String,
      required: true,
    },
  },
  methods: {
    async downloadOutputForm() {
      const res = await getShippingOutputForm(this.id);
      this.downloadAsExcel(res);
      this.columnsDialog = false;
    },
    downloadAsExcel(fileData) {
      const blob = new Blob([fileData], { type: "application/xlsx" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Поставка № ${this.number}.xlsx`;
      link.click();
    },
  },
};
</script>
